/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { WalletApplicationId } from "./WalletApplicationId";
import { WalletApplicationStatus } from "./WalletApplicationStatus";
import * as t from "io-ts";

// required attributes
const WalletApplicationInfoR = t.interface({
  name: WalletApplicationId,

  status: WalletApplicationStatus
});

// optional attributes
const WalletApplicationInfoO = t.partial({});

export const WalletApplicationInfo = t.intersection(
  [WalletApplicationInfoR, WalletApplicationInfoO],
  "WalletApplicationInfo"
);

export type WalletApplicationInfo = t.TypeOf<typeof WalletApplicationInfo>;
